// utils/koToEnKeyboard.ts
const KO_TO_EN: Record<string, string> = {
  // 기본자모(소문자 키 대응)
  ㅂ: "Q",
  ㅈ: "W",
  ㄷ: "E",
  ㄱ: "R",
  ㅅ: "T",
  ㅛ: "Y",
  ㅕ: "U",
  ㅑ: "I",
  ㅐ: "O",
  ㅔ: "P",
  ㅁ: "A",
  ㄴ: "S",
  ㅇ: "D",
  ㄹ: "F",
  ㅎ: "G",
  ㅗ: "H",
  ㅓ: "J",
  ㅏ: "K",
  ㅣ: "L",
  ㅋ: "Z",
  ㅌ: "X",
  ㅊ: "C",
  ㅍ: "V",
  ㅠ: "B",
  ㅜ: "N",
  ㅡ: "M",
};

const HANGUL_REGEX = /[\u3131-\u318E\uAC00-\uD7A3]/; // 자모/완성형 모두

export function koToEnKeyboard(input: string): string {
  if (!input) return input;
  if (!HANGUL_REGEX.test(input)) return input; // 한글 없으면 스킵

  // 바코드는 연속키 입력이라 완성형으로 조합되는 경우는 드묾.
  // 그래도 완성형(가~힣)이 들어오면 그대로 둡니다(치환 불가).
  return [...input].map((ch) => KO_TO_EN[ch] ?? ch).join("");
}
